import { render, staticRenderFns } from "./PageLinkButton.vue?vue&type=template&id=49c1e4e0&scoped=true&"
import script from "./PageLinkButton.vue?vue&type=script&lang=js&"
export * from "./PageLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./PageLinkButton.vue?vue&type=style&index=0&id=49c1e4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c1e4e0",
  null
  
)

export default component.exports